import { Workbook, Worksheet } from 'exceljs';

function sanitizeSheetName(name: string): string {
  const cleaned = String(name || '')
    .replace(/[\\/*?:[\]]/g, '')
    .trim();
  return (cleaned || 'Report').slice(0, 31);
}

export function addAoaSheet(
  workbook: Workbook,
  sheetName: string,
  rows: Array<Array<string | number>>
): Worksheet {
  const sheet = workbook.addWorksheet(sanitizeSheetName(sheetName));
  rows.forEach((row) => sheet.addRow(row));
  return sheet;
}

export async function downloadWorkbook(
  workbook: Workbook,
  filename: string
): Promise<void> {
  const out = filename.endsWith('.xlsx') ? filename : `${filename}.xlsx`;
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob(
    [buffer instanceof ArrayBuffer ? buffer : (buffer as ArrayBufferLike)],
    {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    }
  );
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = out;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
